import Cookies from 'universal-cookie';

export const getLayers = (cookieString = '') => {
  const cookies = new Cookies(cookieString);

  const basketCookies = cookies.get<string>('cartInfo');
  const basket = basketCookies?.split(';').map((item: string) => item.slice(0, item.indexOf(':'))) ?? [];

  const comparisonCookies = cookies.get<string>('comparison');
  const comparison = comparisonCookies?.split(',') ?? [];

  const shoppingListCookies = cookies.get<string>('shoppingList');
  const shoppingList =
    shoppingListCookies?.split(';').map((item: string) => item.slice(0, item.indexOf(':'))) ?? [];

  const layersObj = {
    basket,
    comparison,
    shoppingList,
  };

  return layersObj;
};
